module.exports = require("core-js/library/fn/symbol/iterator");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/symbol/iterator.js
// module id = 121
// module chunks = 35783957827783 114276838955818 162898551421021